import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'semantic-ui-react';
import { closeIconSvg } from '../../../../HelperMethods/constants';
import styles from './DropdownModal.module.css';

export default function DropdownModal({
  openModal,
  trigger,
  setOpenModal,
  title,
  content,
  size = 'tiny',
  showModalHeader = true,
}) {
  return (
    <Modal
      open={openModal}
      onOpen={() => {
        setOpenModal(true);
      }}
      onClose={() => {
        setOpenModal(false);
      }}
      size={size}
      className={styles.DropdownModal}
      {...(trigger ? { trigger } : {})}
      closeIcon={
        showModalHeader ? (
          <img
            src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(closeIconSvg)}`}
            style={{ cursor: 'pointer', position: 'absolute', top: '19px', right: '19px' }}
            alt="Close Icon"
          />
        ) : null
      }
    >
      {showModalHeader && <Modal.Header>{title}</Modal.Header>}
      <Modal.Content>{content}</Modal.Content>
    </Modal>
  );
}

DropdownModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  trigger: PropTypes.node,
  size: PropTypes.string,
  showModalHeader: PropTypes.bool.isRequired,
};

DropdownModal.defaultProps = {
  trigger: null,
};
